var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapChungTu70C0A28C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4374",
    "data-name": "Ellipse 4374",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(0 0)",
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.909,
    y1: 1,
    x2: 0.294,
    y2: -0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.074,
    y1: 0.282,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8983e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba30",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LapChungTu",
    transform: "translate(-892 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53141",
    "data-name": "Group 53141",
    transform: "translate(11518 5867)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4372",
    "data-name": "Ellipse 4372",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10626 -5574)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-10626 -5574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53139",
    "data-name": "Group 53139",
    transform: "translate(14.464 23.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22825",
    "data-name": "Rectangle 22825",
    width: 51.072,
    height: 60.294,
    rx: 4,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22802",
    "data-name": "Rectangle 22802",
    width: 22.837,
    height: 3.901,
    rx: 1.95,
    transform: "translate(5.14 4.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22803",
    "data-name": "Rectangle 22803",
    width: 13.425,
    height: 3.901,
    rx: 1.95,
    transform: "translate(5.14 10.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22804",
    "data-name": "Rectangle 22804",
    width: 40.309,
    height: 4.169,
    rx: 2.085,
    transform: "translate(5.14 20.562)",
    fill: "#73d0f8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22805",
    "data-name": "Rectangle 22805",
    width: 21.909,
    height: 4.169,
    rx: 2.085,
    transform: "translate(5.14 27.62)",
    fill: "#73d0f8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75984",
    "data-name": "Path 75984",
    d: "M1.2,12.534C5.844,10.545,9.449,1.388,4.891.808-.574.112.457,12.037,4.642,11.332s9.572-5.539,6.671-6.8c-3.729-1.616-3.854,6.174-1.16,6.505S13.1,7.23,14.214,7.23s-.249,3.066,1.45,2.859.746-3.356,2.528-3.356",
    transform: "translate(19.258 56.563)",
    fill: "none",
    stroke: "#007aff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Component_154_9",
    "data-name": "Component 154 \\u2013 9",
    transform: "translate(946 348)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4387",
    "data-name": "Ellipse 4387",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#ffba30",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75998",
    "data-name": "Path 75998",
    d: "M51.414,26.118,39.61,19.5,38,31.484,46.049,35.6Z",
    transform: "translate(-25.838 -12.524)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53205",
    "data-name": "Group 53205",
    transform: "translate(6.797 6.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75999",
    "data-name": "Path 75999",
    d: "M29.439,19a1.431,1.431,0,0,0-1.431,1.431V23.65a.358.358,0,0,1-.358.358H24.431a1.431,1.431,0,1,0,0,2.862H27.65a.358.358,0,0,1,.358.358v3.219a1.431,1.431,0,0,0,2.862,0V27.228a.358.358,0,0,1,.358-.358h3.219a1.431,1.431,0,1,0,0-2.862H31.228a.358.358,0,0,1-.358-.358V20.431A1.431,1.431,0,0,0,29.439,19Z",
    transform: "translate(-23 -19)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapChungTu70C0A28C);
export default __webpack_public_path__ + "static/media/LapChungTu.70c0a28c.c42469acfc3e344ade03e89e0bec5f35.svg";
export { ForwardRef as ReactComponent };